export const API_URL = process.env.NODE_ENV === "development" 

    //development
    // ? "http://192.168.23.140:5000"
    ? "http://localhost:5000"

    //release
    : "https://bgawarranty2.azurewebsites.net"
